// Discount configuration
// Set to false to disable a deal completely
export const discountConfig = {
  // 2× large mask + 2× shampoo deal (1199 Kč)
  deal22: false,
  
  // 1× shampoo + 1× large mask deal (599 Kč)
  deal11: true,
  
  // 1× shampoo + 1× large mask + 1× small color deal (799 Kč)
  deal111: true,

  // 1× large mask + 1× small color deal (549 Kč)
  deal101: true,
  
  // Mask + small color discount (71 Kč per pair)
  maskColorDiscount: false,
  
  // 2+1 zdarma for 60ml colors
  deal21Zdarma: false,
  
  // Free shipping for everything (no line item on invoice/Stripe)
  freeShippingForEverything: false,
};

